export default {
    CARD_TRANSACTION_MERCHANT_TITLE: 'Merchant details',
    CARD_TRANSACTION_OTHER_COLUM_TITLE: 'Other details',
    CARD_TRANSACTION_TITLE: 'Transaction',
};
